import React from 'react';
import QueryProvider from '@/modules/QueryProvider';
import OpportunitiesFilterParams from '../constants/OpportunitiesFilterParams';
import OpportunitiesSortableFields from '../constants/OpportunitiesSortableFields';

export default function GroupedOpportunitiesQueryProvider({
  children,
  sortingPrefix,
  paginationPrefix,
}: {
  children: React.ReactNode;
  sortingPrefix: string;
  paginationPrefix: string;
}) {
  return (
    <QueryProvider
      defaultPageSize={12}
      filterParams={OpportunitiesFilterParams}
      isPaginated
      sortableFields={OpportunitiesSortableFields}
      sortingPrefix={sortingPrefix}
      paginationPrefix={paginationPrefix}
    >
      {children}
    </QueryProvider>
  );
}
